module.exports = __webpack_public_path__ + "static/media/starfield.49b3a5a2.png";